import React from 'react';
import ABadge from 'antd-mobile/lib/badge';



export default class Badge extends ABadge {}
